var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',_vm._g(_vm._b({attrs:{"show-password":""},model:{value:(_vm._password),callback:function ($$v) {_vm._password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"_password"}},'el-input',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"prefix"},[_vm._t("prefix")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }